<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-dialog v-model="dialogExcedentes" persistent max-width="800px">
          <v-card>
            <v-card-title>Acción a Tomar con los Excedentes</v-card-title>
            <v-card-text>
              <v-row class="ma-0 pa-0 justify-center">
                <div class="headline red--text">
                  Existen Artículos Excedentes. ¿Qué desea hacer con ellos?
                </div>
              </v-row>
              <v-row class="ma-0 pa-0">
                <div
                  class="v-btn v-btn--contained green theme--dark headline ma-5 pa-5"
                  @click="finalizarOperacionSend(false)"
                >
                  Mantener Operación
                </div>
                <v-spacer></v-spacer>
                <div
                  class="v-btn v-btn--contained red theme--dark headline ma-5 pa-5"
                  @click="finalizarOperacionSend(true)"
                >
                  Enviar a Almacén
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogExcedenteAlmacen" persistent max-width="800px">
          <v-card>
            <v-card-title>Excedentes a Enviar al Almacén</v-card-title>
            <v-card-text>
              <ul>
                <li
                  v-for="(exc, idx) in listaExcedentes"
                  :key="'exc-' + idx"
                  class="headline"
                >
                  {{ exc.cantidad }} {{ exc.unidad }} - {{ exc.articulo }}
                </li>
              </ul>
              <v-row class="ma-0 pa-0 justify-center">
                <div
                  class="v-btn v-btn--contained red theme--dark headline ma-5 pa-5"
                  @click="cerrarListaExcedentes()"
                >
                  Cerrar
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogIndicarCantidad" persistent max-width="800px">
          <v-card>
            <v-card-title>Indicar Cantidad Producida</v-card-title>
            <v-card-text>
              <v-row justify="center" class="ma-2 pa-0">
                <v-col cols="6">
                  <v-text-field
                    v-model="cantidad"
                    type="number"
                    min="0"
                    :label="'Máximo: ' + maximoProduccionLabel"
                    :max="maximoProduccion"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="ma-2 pa-0">
                <v-progress-linear
                  v-model="porcentajeAvance"
                  :color="(operacion.cantidad - cantidad >= 0) ? 'primary' : 'red'"
                  height="25"
                >
                  <strong>
                    {{
                      isFinite(porcentajeAvance)
                        ? porcentajeAvance.toFixed(2) + "%"
                        : "Ilimitada"
                    }}
                  </strong>
                </v-progress-linear>
              </v-row>

              <v-switch
                label="Especificar Hora de Término"
                v-model="horaDiferente"
              ></v-switch>

              <v-col v-if="horaDiferente" cols="12">
                <VueCtkDateTimePicker
                  v-model="horaFin"
                  label="Fecha de Ingreso"
                  format="YYYY-MM-DD HH:mm"
                  formatted="YYYY-MM-DD HH:mm"
                  noHeader
                  buttonNowTranslation="Ahora"
                />
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" text @click="resetFinalizarOperacion">Cancelar</v-btn>
              <v-btn
                color="red"
                :loading="loadBottom"
                text
                @click="finalizarOperacion"
              >Terminar Operación</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialogParoTipo" persistent max-width="800px">
          <v-card>
            <v-card-title>Seleccione el Motivo del Paro</v-card-title>
            <v-card-text>
              <v-select
                v-model="paroTipo"
                :items="paroTipos"
                item-text="nombre"
                item-value="idParoTipo"
              ></v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" text @click="resetParo">Cancelar</v-btn>
              <v-btn color="red" text @click="iniciarParo">Iniciar Paro</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialogErrorTermino" persistent max-width="500px">
          <v-card>
            <v-card-text class="text-center justify-center">
              <v-icon size="200px" color="red">mdi-alert</v-icon>
              <div class="headline">
                La Fecha y Hora de Término es inferior a la de Inicio.
              </div>
              <v-btn
                class="ma-5 pa-5 blue"
                dark
                @click="dialogErrorTermino = false"
              >
                Cerrar
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-card>
          <v-row>
            <v-col cols="6">
              <v-card-title>
                <div v-if="paro" class="red--text headline">
                  Operación Pausada: {{ paroMotivo }}
                </div>
                <div class="headline">
                  {{ etiquetaOperacion }}
                </div>
              </v-card-title>

              <v-card-subtitle>
                <div>{{ descripcionOperacion }}</div>
                <div v-if="operacion.idSubpaso">
                  [{{ operacion.codigoSubpaso }}] - {{ operacion.nombreSubpaso }}
                </div>
                <div class="red--text" v-if="operacion.mensaje">
                  Especial: {{ operacion.mensaje }}
                </div>
                <br>

                <div v-if="sesion && (!sesion.integrantes || sesion.integrantes.length === 0)">
                  Operador: {{ operadorMostrado }}
                </div>
                <div v-else-if="sesion && sesion.integrantes && sesion.integrantes.length > 0">
                  Operadores:
                  <ul>
                    <li v-for="(operador, idx) in sesion.integrantes" :key="'op-' + idx">
                      {{ operador.nombre }}
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <em class="grey--text">Sin operador asignado</em>
                </div>
              </v-card-subtitle>
            </v-col>

            <v-col cols="2" class="align-self-center">
              <v-btn
                v-if="!operacionPausada && permisoVista('control','c')"
                color="red"
                dark
                large
                @click="mostrarParo"
              >
                <v-icon x-large>mdi-pause-circle-outline</v-icon>
              </v-btn>

              <v-btn
                v-if="operacionPausada && permisoVista('control','c')"
                color="green"
                dark
                large
                @click="terminarParo"
              >
                <v-icon x-large>mdi-play-circle-outline</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="2" class="align-self-center">
              <div class="headline">{{ formatoTiempo(tiempo) }}</div>
            </v-col>

            <v-col cols="2" class="align-self-center">
              <v-btn
                v-if="permisoVista('control','c')"
                color="green"
                @click="indicarCantidad"
              >{{ finalizarLabel }}</v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <br>
  </v-container>
</template>

<script>
import moment from "moment";
import underscore from "underscore";
import axios from "axios";
import { mapState } from "vuex";

export default {
  props: {
    operacion: Object,
    sesiones: Array,
    paros: Array,
    paroTipos: Array,
    area: Object,
    detalle: Object,
  },
  data: () => ({
    tiempo:0,
    sesion:{
      idEquipo:-1,
      idOperador:-1,
      integrantes:[],
      nombre:"",
    },
    listaExcedentes:[],
    cantidad:0,
    dialogExcedentes:false,
    dialogExcedenteAlmacen:false,
    dialogIndicarCantidad:false,
    paro: null,
    dialogParoTipo:false,
    paroTipo:-1,
    horaFin: null,
    horaDiferente:false,
    dialogErrorTermino:false,
    loadBottom:false,
    forzarCierrePorReporte: false,
  }),
  computed: {
    ...mapState(["finalizarLabel", "operacionesCantidadCero"]),

    etiquetaOperacion() {
      return (
        (this.operacion.clave || "ODT-" + this.operacion.idTrabajoOrden) +
        " - " +
        this.operacion.cantidadProducir +
        " " +
        this.operacion.articuloProducir
      );
    },
    descripcionOperacion() {
      return (
        this.operacion.cantidad +
        (this.operacion.cantidadExcedente > 0
          ? " + " + this.operacion.cantidadExcedente
          : "") +
        " - " +
        this.operacion.articulo
      );
    },
    maximoProduccionLabel() {
      return this.operacion.excedentes || this.operacionesCantidadCero
        ? "Ilimitado"
        : this.operacion.cantidad;
    },
    maximoProduccion() {
      return this.operacion.excedentes || this.operacionesCantidadCero
        ? Infinity
        : this.operacion.cantidad;
    },
    porcentajeAvance() {
      if (!this.operacion.cantidad || this.operacion.cantidad === 0) return 0;
      const val = (this.cantidad / this.operacion.cantidad) * 100;
      return isNaN(val) ? 0 : val;
    },
    operacionPausada() {
      this.paro = this.paros.find(
        (p) => p.idOperacionReal === this.detalle.idOperacionReal
      );
      return !!this.paro;
    },
    paroMotivo() {
      if (!this.paro) return "";
      const tipo = this.paroTipos.find(
        (pt) => pt.idParoTipo === this.paro.idParoTipo
      );
      return tipo ? tipo.nombre : "";
    },
    operadorMostrado() {
      const op0 = this.detalle?.operadoresReales?.[0];
      if (op0?.idPersona > 0) return `${op0.nombre} ${op0.paterno ?? ""} ${op0.materno ?? ""}`.trim();

      const rp0 = this.detalle?.reportesPorOperador?.[0];
      if (rp0?.idPersona > 0) return `${rp0.nombre} ${rp0.paterno ?? ""} ${rp0.materno ?? ""}`.trim();

      return this.sesion?.nombre || "Sin operador asignado";
    },
  },

  created() {
    this.actualizarTiempo();
    this.getOperadores();
  },
  watch: {
    // Cuando cambias de operación (idOperacionReal cambia), recalcula
    "detalle.idOperacionReal": {
      immediate: true,
      handler() {
        if (this._getOperadoresTimer) clearTimeout(this._getOperadoresTimer);
        this.getOperadores();
      },
    },

    // Cuando llegan sesiones (async), recalcula
    sesiones: {
      deep: true,
      handler() {
        if (this._getOperadoresTimer) clearTimeout(this._getOperadoresTimer);
        this.getOperadores();
      },
    },

    detalle: {
      deep: true,
      handler() {
        if (this._getOperadoresTimer) clearTimeout(this._getOperadoresTimer);
        this.getOperadores();
      },
    },
  },
  beforeDestroy() {
    if (this._getOperadoresTimer) clearTimeout(this._getOperadoresTimer);
  },

  methods: {
    actualizarTiempo() {
      setTimeout(() => {
        this.calcularTiempo();
        this.actualizarTiempo();
      }, 1000);
    },
    calcularTiempo() {
      if (!this.detalle || !this.detalle.comenzo) {
        this.tiempo = 0;
      } else {
        this.tiempo = moment().utc().diff(moment(this.detalle.comenzo), "seconds");
      }
    },
    formatoTiempo(segundos) {
      if (!segundos) return "00:00:00";
      const horas = Math.floor(segundos / 3600);
      const minutos = Math.floor((segundos % 3600) / 60);
      const segs = segundos % 60;
      return `${this.dosDigitos(horas)}:${this.dosDigitos(minutos)}:${this.dosDigitos(segs)}`;
    },
    dosDigitos(num) {
      return ("0" + num).slice(-2);
    },

    getOperadores() {
      if (!this.detalle) return;

      // Normalizar fuentes
      const opsReales = Array.isArray(this.detalle.operadoresReales)
        ? this.detalle.operadoresReales
        : [];

      const reps = Array.isArray(this.detalle.reportesPorOperador)
        ? this.detalle.reportesPorOperador
        : [];

      const sesiones = Array.isArray(this.sesiones) ? this.sesiones : [];

      // regla única del flag
      const debeForzar = (opsReales.length === 0 && reps.length > 0);
      this.forzarCierrePorReporte = debeForzar;

      // Si no hay datos de ningún lado, reintentar
      if (opsReales.length === 0 && reps.length === 0) {
        if (this._getOperadoresTimer) clearTimeout(this._getOperadoresTimer);
        this._getOperadoresTimer = setTimeout(() => this.getOperadores(), 500);
        return;
      }

      const setSesionFallback = (idPersona, nombre, integrantes = []) => {
        const pid = Number(idPersona) || -1;
        this.sesion = {
          idEquipo: -1,
          idOperador: pid,
          integrantes: Array.isArray(integrantes) ? integrantes : [],
          nombre: nombre || (pid > 0 ? "Operador" : "Sin operador asignado"),
        };
      };

      const sortNum = (arr) => arr.slice().sort((a, b) => Number(a) - Number(b));

      // 1) Match con sesiones usando operadoresReales (si existen)
      if (opsReales.length > 0 && sesiones.length > 0) {
        if (opsReales.length === 1) {
          const idPersonaBuscada = Number(opsReales[0].idPersona) || -1;
          const ses = sesiones.find((s) => Number(s?.idOperador) === idPersonaBuscada);
          if (ses) {
            this.sesion = ses;
            return;
          }
        } else {
          const idsPersonasDetalle = sortNum(opsReales.map((o) => Number(o.idPersona) || -1));

          const ses = sesiones.find((s) => {
            const integrantes = Array.isArray(s?.integrantes) ? s.integrantes : [];
            const idsIntegrantes = sortNum(integrantes.map((i) => Number(i.idOperador) || -1));

            return (
              idsIntegrantes.length === idsPersonasDetalle.length &&
              idsIntegrantes.every((id, idx) => id === idsPersonasDetalle[idx])
            );
          });

          if (ses) {
            this.sesion = ses;
            return;
          }
        }
      }

      // 2) Si no hay operadoresReales o no coincidió, usar reportesPorOperador
      if (reps.length > 0) {
        // Si hay sesiones, intentar match por idPersona(s)
        if (sesiones.length > 0) {
          const idsPersonasRep = sortNum(
            reps.map((r) => Number(r.idPersona) || -1).filter((x) => x > 0)
          );

          if (idsPersonasRep.length === 1) {
            const idPersonaBuscada = idsPersonasRep[0];
            const ses = sesiones.find((s) => Number(s?.idOperador) === idPersonaBuscada);
            if (ses) {
              this.sesion = ses;
              return;
            }
          } else if (idsPersonasRep.length > 1) {
            const ses = sesiones.find((s) => {
              const integrantes = Array.isArray(s?.integrantes) ? s.integrantes : [];
              const idsIntegrantes = sortNum(integrantes.map((i) => Number(i.idOperador) || -1));
              return (
                idsIntegrantes.length === idsPersonasRep.length &&
                idsIntegrantes.every((id, idx) => id === idsPersonasRep[idx])
              );
            });

            if (ses) {
              this.sesion = ses;
              return;
            }
          }
        }

        // Fallback desde reportesPorOperador
        const rp0 = reps[0];
        const fallbackIdPersona = Number(rp0.idPersona) || -1;
        const fallbackNombre = rp0.nombre || rp0.nombrePersona || "Operador";

        const integrantes = reps
          .map((r) => ({
            idOperador: Number(r.idPersona) || -1,
            nombre: r.nombre || r.nombrePersona || "Operador",
          }))
          .filter((x) => x.idOperador > 0);

        setSesionFallback(
          fallbackIdPersona,
          fallbackNombre,
          integrantes.length ? integrantes : [{ idOperador: fallbackIdPersona, nombre: fallbackNombre }]
        );

        if (sesiones.length === 0) {
          if (this._getOperadoresTimer) clearTimeout(this._getOperadoresTimer);
          this._getOperadoresTimer = setTimeout(() => this.getOperadores(), 500);
        }
        return;
      }

      // 3) Último fallback: operadoresReales sin sesiones
      if (opsReales.length > 0) {
        const idPersona = Number(opsReales[0].idPersona) || -1;
        const nombre = opsReales[0].nombre || "Operador";
        const integrantes = opsReales
          .map((o) => ({ idOperador: Number(o.idPersona) || -1, nombre: o.nombre || "Operador" }))
          .filter((x) => x.idOperador > 0);

        setSesionFallback(idPersona, nombre, integrantes);
        return;
      }

      setSesionFallback(-1, "Sin operador asignado", []);
    },

    getIdPersonaParaCerrar() {
      const op0 = this.detalle?.operadoresReales?.[0];
      const idOps = Number(op0?.idPersona || -1);
      if (idOps > 0) return idOps;

      const rp0 = this.detalle?.reportesPorOperador?.[0];
      const idRep = Number(rp0?.idPersona || -1);
      if (idRep > 0) return idRep;

      // último recurso (si tu sesion realmente guarda idPersona)
      const idSesion = Number(this.sesion?.idOperador || -1);
      if (idSesion > 0) return idSesion;

      return -1;
    },

    indicarCantidad() {
      this.dialogIndicarCantidad = true;
    },
    resetFinalizarOperacion() {
      this.cantidad = 0;
      this.dialogIndicarCantidad = false;
      this.horaFin = null;
      this.horaDiferente = false;
    },
    finalizarOperacion() {
      this.finalizarOperacionSend();
    },
    finalizarOperacionSend(enviarAlmacen = false){
      this.dialogExcedentes = false;
      this.loadBottom=true;
      const idPersona = this.getIdPersonaParaCerrar();
      if (idPersona <= 0) {
        this.loadBottom = false;
        return;
      }
      axios
        .put("/ComandoYControl/TerminarOperacion",{
          IdArea: this.area.idArea,
          IdOperacionReal: this.detalle.idOperacionReal,
          Cantidad: this.cantidad,
          EnviarAlmacen: enviarAlmacen,
          Termino: this.horaDiferente ? this.horaFin: null,
          IdPersona: idPersona,
          ForzarCierrePorReporte: (this.detalle?.operadoresReales?.length ?? 0) === 0 && (this.detalle?.reportesPorOperador?.length ?? 0) > 0,
        })
        .then((response) => {
          if(response.data.length){
            this.listaExcedentes = response.data;
            this.dialogExcedenteAlmacen = true;
          }
          this.resetFinalizarOperacion();
          this.$emit("change", null);
        })
        .catch((error) => {
          if (error.response?.status === 463) {
            this.resetFinalizarOperacion();
            this.forzarCierrePorReporte = false;
            this.dialogErrorTermino = true;
          } else console.log(error);
        })
        .finally(() => (this.loadBottom = false));
    },
    resetParo(){
      this.dialogParoTipo = false;
      this.paroTipo = -1;
    },
    mostrarParo(){
      this.dialogParoTipo = true;
    },
    iniciarParo(){
      axios
        .post("/ComandoYControl/IniciarParo",{
          IdArea:this.area.idArea,
        IdParoTipo:this.paroTipo,
        IdTrabajoOrden:this.operacion.idTrabajoOrden,
        IdTrabajoOrdenDetalle:this.operacion.idTrabajoOrdenDetalle,
        IdOperacionReal:this.detalle.idOperacionReal,
        Manual: true
        })
        .then(() => {
          this.resetParo();
          this.$emit("update",null);
        })
        .catch((error) => console.log(error));
    },
    terminarParo() {
      axios
        .put("/ComandoYControl/TerminarParo", {
          IdArea: this.area.idArea,
          IdParo: this.paro ? this.paro.idParo : 0,
          IdTrabajoOrden: this.operacion.idTrabajoOrden,
          IdTrabajoOrdenDetalle: this.operacion.idTrabajoOrdenDetalle,
          IdOperacionReal: this.detalle.idOperacionReal,
          Manual: true
        })
        .then(() => this.$emit("update", null))
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style scoped>
.red--text {
  font-weight: bold;
}
</style>
